
import DirectUp from "../../../assets/filled/DirectUp.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DirectUpIcon({ className, dataTestid = "DirectUpIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <DirectUp data-testid={dataTestid} className={classes} {...rest} />
  );
}
